import { Star } from 'lucide-react';
import './Testimonials.css';

const testimonials = [
    {
        quote:
            "Revitrone has completely transformed how our team approaches design modeling. What used to take hours now takes minutes.",
        name: 'Sarah Chen',
        role: 'Principal Architect',
        avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face',
        rating: 5,
    },
    {
        quote:
            "The AI understands architectural context like no other tool. It's like having a senior architect review every decision.",
        name: 'Marcus Rodriguez',
        role: 'Design Director',
        avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
        rating: 5,
    },
    {
        quote:
            "We've reduced our project timelines by 40% since adopting Revitrone. The ROI is incredible.",
        name: 'Emily Watson',
        role: 'Technical Lead',
        avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face',
        rating: 5,
    },
];

const stats = [
    { value: '50K+', label: 'Architects' },
    { value: '2M+', label: 'Models Generated' },
    { value: '99.9%', label: 'Uptime' },
    { value: '4.9/5', label: 'User Rating' },
];

export default function Testimonials() {
    return (
        <section className="testimonials">
            <div className="testimonials__container">
                <div className="testimonials__header">
                    <h2 className="testimonials__kicker">Trusted by architects</h2>
                    <h3 className="testimonials__title">Loved by teams worldwide</h3>
                </div>

                <div className="testimonials__stats">
                    {stats.map((stat) => (
                        <div key={stat.label} className="testimonials__stat">
                            <span className="testimonials__statValue">{stat.value}</span>
                            <span className="testimonials__statLabel">{stat.label}</span>
                        </div>
                    ))}
                </div>

                <div className="testimonials__grid">
                    {testimonials.map((t) => (
                        <div key={t.name} className="testimonials__card">
                            <div className="testimonials__stars">
                                {Array.from({ length: t.rating }).map((_, i) => (
                                    <Star key={i} className="testimonials__star" aria-hidden="true" />
                                ))}
                            </div>
                            <blockquote className="testimonials__quote">"{t.quote}"</blockquote>
                            <div className="testimonials__author">
                                <img
                                    className="testimonials__avatar"
                                    src={t.avatar}
                                    alt={t.name}
                                    loading="lazy"
                                />
                                <div className="testimonials__authorInfo">
                                    <span className="testimonials__name">{t.name}</span>
                                    <span className="testimonials__role">{t.role}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
